import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getRequestOrderBBList(context, payload) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inbound_asn_reopen/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getRequestDetail(context, id) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inbound_asn_reopen/edit/${id}`)
      .then((res) => res.data);
  },
  getReceiptNumberList(context, payload) {
    if (payload.type) {
      return axios
        .post(`/api/btb_get_receipt_number?type=${payload.type}`, payload)
        .then((res) => res.data);
    } else {
      return axios
        .post(`/api/btb_get_receipt_number`, payload)
        .then((res) => res.data);
    }
  },
  addRequest(context, payload) {
    return axios
      .post("/api/fulfillmentbb/b2b_inbound_asn_reopen/create ", payload)
      .then((res) => res.data);
  },

  approveRequest(context, payload) {
    return axios
      .patch(
        `/api/fulfillmentbb/b2b_inbound_asn_reopen/update/${payload.id}`,
        payload.data
      )
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
